var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"equity"},[_c('web-header',{ref:"webHeaderRef",attrs:{"language":_vm.type}}),(_vm.type == 'en')?_c('english-wrap',{on:{"login":_vm.login}}):_c('chinese-wrap',{on:{"login":_vm.login}}),_c('web-footer',{attrs:{"language":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }